import React from "react";
import Drawer from "@mui/material/Drawer";
import clsx from "clsx";
import List from "@mui/material/List";
import { makeStyles } from "@mui/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ItemMeta } from "semantic-ui-react";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;
class CategoryDrawer extends React.Component {
  state = {
    loading: true,
    show: false,
  };
  render() {
    const handleChangee = (id, title) => {
      localStorage.setItem("categoryIdMultiVnedor", id);
      localStorage.setItem("categoryTitleMultiVnedor", title);
      window.location.reload();
    };
    const toggleDrawer = (anchor, open) => (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      this.setState({ ...this.state, [anchor]: open });
    };

    const list = (anchor) => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === "top" || anchor === "bottom",
        })}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          <div className="drawerMap">
            <div className="ChoseAddress">
              {this.props.services.length != 0 &&
              this.props.services !== null ? (
                this.props.services.map((item, i) => (
                  <RadioGroup
                    aria-label="لیست آدرس های من"
                    value={this.state.value}
                    name="gender1"
                    onClick={(e) => handleChangee(item.id, item.title)}
                    defaultValue={`${localStorage.getItem(
                      "categoryTitleMultiVnedor"
                    )}`}
                  >
                    <FormControlLabel
                      key={i}
                      id={`${item.id}`}
                      value={`${item.title}`}
                      control={<Radio />}
                      label={`${item.title}`}
                    />
                  </RadioGroup>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </List>
      </div>
    );
    return (
      <>
        {["bottom"].map((anchor) => (
          <React.Fragment>
            <>
              <div className="position" onClick={toggleDrawer(anchor, true)}>
                <img src="/public/assets/icons/Grouping.svg" alt="pic"/>
                <span>دسته بندی</span>
                <img
                  className="downArrowVendor"
                  src="/public/assets/icons/downArrowVendor.svg"
                alt="pic"/>
              </div>
              <Drawer
                anchor={anchor}
                open={this.state[anchor]}
                onClose={toggleDrawer(anchor, false)}
              >
                {list(anchor)}
              </Drawer>
            </>
          </React.Fragment>
        ))}
      </>
    );
  }
}
export default CategoryDrawer;
